const MinusQty = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line x1="3.5" y1="11.5" x2="20.5" y2="11.5" stroke="black" />
        </svg>
    )
}

export default MinusQty
